import { render, staticRenderFns } from "./ValuationReview.vue?vue&type=template&id=064d40e8"
import script from "./ValuationReview.vue?vue&type=script&lang=js"
export * from "./ValuationReview.vue?vue&type=script&lang=js"
import style0 from "./ValuationReview.vue?vue&type=style&index=0&id=064d40e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports